<cb-select [(ngModel)]="value" [options]="options()" [groupedOptions]="groupedOptions()"
    [disabledOptions]="disabledOptions()" [disableCheckCallback]="selectDisableCheckCallback" [filter]="filter()"
    [translateGroupLabels]="translateGroupLabels()" [translateOptions]="translateOptions()" [async]="async()"
    [groupedAsync]="groupedAsync()" [placeholder]="placeholder()" [label]="label()" [hint]="hint()" [info]="info()"
    [multiline]="true" [required]="required() ?? false" [disabled]="disabled() ?? false" [icon]="icon()"
    [resetButton]="resetButton()" [error]="error()" [selectionMode]="'multiple'" (change)="change.emit($event)"
    [enableFreeText]="true">

    <ng-template #SelectValueTemplate let-option>
        <cb-chip iconType="x-close" [color]="option.color ?? 'auto'" size="sm" [customColor]="option.color"
            [label]="(translateOptions())? (option.label | translate) : option.label"
            (closeChip)="removeTag(option)"></cb-chip>
    </ng-template>

    <ng-template #SelectOptionTemplate let-option>
        <cb-chip [color]="option.color ?? 'auto'" size="sm" [customColor]="option.color"
            [label]="(translateOptions())? (option.label | translate) : option.label"></cb-chip>
    </ng-template>
</cb-select>